<template>
  <s-page class="max-w-2xl" v-if="isDataLoaded">
    <inventory-list />
    <modal-submit-order />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import InventoryList from '@/components/InventoryList'
import ModalSubmitOrder from '@/components/ModalSubmitOrder'
import { mapState } from 'vuex'
export default {
  name: 'Inventory',
  components: {
    SPage,
    InventoryList,
    ModalSubmitOrder
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
